import React, { useEffect, useState } from 'react';
import { LogOut, User } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import { cerrarSesion } from '../../lib/cerrarSesion';

interface AccountProps {
  setError: (error: string | null) => void;
  setSuccess: (success: string | null) => void;
}

export const Account: React.FC<AccountProps> = ({ setError, setSuccess }) => {
  const [userData, setUserData] = useState<{ email: string | null; name: string | null }>({
    email: null,
    name: null
  });

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // Get the authenticated user
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          // Set the email from auth user data
          setUserData(prevData => ({
            ...prevData,
            email: user.email || null
          }));
          
          // Fetch the name from the profiles table
          const { data: profileData, error: profileError } = await supabase
            .from('profiles')
            .select('name')
            .eq('id', user.id)
            .single();
            
          if (profileError) {
            console.error('Error fetching profile data:', profileError);
          } else if (profileData) {
            setUserData(prevData => ({
              ...prevData,
              name: profileData.name
            }));
          }
        }
      } catch (err) {
        console.error('Error fetching user data:', err);
      }
    };

    fetchUserData();
  }, []);

  const handleSignOut = async () => {
    try {
      setError(null);
      await cerrarSesion();
    } catch (err) {
      console.error('Error signing out:', err);
      setError('Error al cerrar sesión. Por favor, inténtalo nuevamente.');
    }
  };

  return (
    /* Sin card propia: el recuadro blanco lo pone la pantalla de Configuración
       (ADR-2026-07-31-configuracion-menu-sobre-gris-sola). Antes esta sección traía la suya y, dentro del panel, quedaban
       dos cards blancas anidadas. */
    <div>
      <div className="pb-5 mb-5 border-b border-neutral-200">
        <h2 className="text-[17px] font-semibold text-brand-black/90">Información</h2>
        <p className="text-[13px] text-neutral-500 mt-0.5">
          Gestiona tu cuenta de usuario
        </p>
      </div>

      <div>
        <div className="space-y-3">
          <div className="p-3 bg-surface-elevated border border-neutral-200 rounded-md">
            <p className="text-[15px] font-medium text-brand-black/90">
              {userData.email || 'Cargando...'}
            </p>
            <p className="text-[13px] text-neutral-500 mt-0.5">
              Correo electrónico de tu cuenta
            </p>
          </div>
          
          <div className="p-3 bg-surface-elevated border border-neutral-200 rounded-md">
            <p className="text-[15px] font-medium text-brand-black/90">
              {userData.name || 'No disponible'}
            </p>
            <p className="text-[13px] text-neutral-500 mt-0.5">
              Nombre de usuario
            </p>
          </div>
          
          <div className="border-t border-neutral-200 pt-4 mt-4">
            <h3 className="text-[13px] font-semibold text-neutral-500 uppercase tracking-wide mb-3">
              Sesión
            </h3>
            <button
              onClick={handleSignOut}
              className="h-10 px-4 bg-red-600 hover:bg-red-700 text-white text-[15px] font-medium rounded-md shadow-sm transition-colors flex items-center gap-2"
            >
              <LogOut className="w-4 h-4" />
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
